import React, {useState, useEffect, memo} from 'react';
import PropTypes from 'prop-types';
import {Backdrop, Button, DialogActions,
  DialogContent, DialogContentText, DialogTitle,
  Fade, makeStyles, Modal, Paper} from '@material-ui/core';
import {useIntl} from 'react-intl';
import {agentDeveloperUtils} from 'wobi-web-common';
import useBrowserUnfocus from '../hooks/useBrowserUnfocus';

const useStyles = makeStyles(() => ({
  closeButton: {
    color: agentDeveloperUtils.getSecondaryColor(300),
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '1',
    userSelect: 'none',
  },
  closeButtonWrapper: {
    '&:hover': {
      transform: 'translateX(50%) scale(1.1)',
    },

    alignItems: 'center',

    backgroundColor: '#fff',

    borderRadius: '50%',

    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',

    cursor: 'pointer',

    display: 'flex',

    height: '36px',

    justifyContent: 'center',

    position: 'absolute',

    // puts the circle above modal
    right: '50%',
    top: '-40px',
    transform: 'translateX(50%)',
    transition: 'all 0.2s ease-in-out',
    width: '36px',
  },
  logo: {
    marginBottom: '20px',
  },
  message: {
    color: agentDeveloperUtils.getSecondaryColor(300),
    marginBottom: '20px',
  },
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',

    // when the user press on the element and it focus its border become blue i dont want that
    MozUserDrag: 'none',

    MozUserSelect: 'none',
    msUserSelect: 'none',
    outline: 'none',

    outlineColor: 'transparent',

    WebkitTapHighlightColor: 'transparent',

    WebkitTouchCallout: 'none',
  },
  modalBtn: {
    fontSize: 18,
    height: 52,
    margin: '20px auto',
    outline: 'none',
    width: '150px',
  },
  paper: {
    alignItems: 'center',

    // when the user press on the element and it focus its border become blue i dont want that
    border: 'none',
    display: 'flex',

    flexDirection: 'column',

    height: 'auto',

    justifyContent: 'center',

    maxWidth: '450px',

    MozUserDrag: 'none',

    MozUserSelect: 'none',

    msUserSelect: 'none',

    outline: 'none',

    outlineColor: 'transparent',

    padding: '20px',

    position: 'relative',

    textAlign: 'center',

    userSelect: 'none',

    // when the user press on the element its border become blue i dont want that
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserDrag: 'none',
    WebkitUserSelect: 'none',

    width: '90%',
  },
  title: {
    color: agentDeveloperUtils.getPrimaryColor(440),
    marginBottom: '10px',
  },
}));
const UnfocusModal = memo(({
  title,
  message,
  unFocusLogicOn = true,
  onClose,
  onButtonClick,
  ButtonText,
  show,
  logo,
  showXButton,
}) => {
  const [isOpen, setIsOpen] = useState(!unFocusLogicOn);
  const isUnfocused = useBrowserUnfocus();
  const classes = useStyles();
  const intl = useIntl();
  const messages = (id) => intl.formatMessage({id});

  useEffect(() => {
    if (isUnfocused && unFocusLogicOn) {
      setIsOpen(true);
    }
  }, [isUnfocused]);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  let showModal = show && isOpen;
  if (!unFocusLogicOn) {
    showModal = show;
  }
  return (
    <Modal
      aria-labelledby='transition-modal-title'
      aria-describedby='transition-modal-description'
      open={showModal}
      className={` ${classes.modal}`}
      closeAfterTransition
      BackdropComponent={Backdrop}
      onClose={handleClose}
    >
      <Fade onExiting={handleClose} in={showModal}>
        <Paper className={classes.paper}>
          {showXButton && (
            <div
              className={classes.closeButtonWrapper}
              role='button'
              tabIndex={0}
              onClick={handleClose}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleClose(e);
                }
              }}
              aria-label='Close'
            >
              <span className={classes.closeButton}>×</span>
            </div>
          )}

          {logo && <img src={logo} alt='Logo' className={classes.logo} />}
          {title && <DialogTitle className={classes.title}>{messages(title)}</DialogTitle>}
          {message && (
            <DialogContent>
              <DialogContentText className={classes.message}>
                {messages(message)}
              </DialogContentText>
            </DialogContent>
          )}
          {onButtonClick && (
            <DialogActions>
              <Button onClick={onButtonClick} color='primary' className={classes.modalBtn}>
                {messages(ButtonText)}
              </Button>
            </DialogActions>
          )}
        </Paper>
      </Fade>
    </Modal>
  );
});

UnfocusModal.propTypes = {
  ButtonText: PropTypes.string,
  logo: PropTypes.string,
  message: PropTypes.string,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  showXButton: PropTypes.bool,
  title: PropTypes.string,
  unFocusLogicOn: PropTypes.bool,
};

export default UnfocusModal;
